<!-- eslint-disable -->
<template>
  <div v-if="isInitiailized" class="G_modal_container">
    <div class="G_modal" :class="{G_hidden_element: activeModal !='default'}">
      <modal-header
        @event-close-child-modals="eventCloseChildModals"
        @event-close-modal="selfClose"
        :title="modalTitle">
      </modal-header>

      <hr>
      <div v-if="C_isLoadingOrgs" class="p2s2m2_loading_state">
        <beat-loader :loading="C_isLoadingOrgs" :color="C_loaderColor" :height="'50px'" :width="'50px'"></beat-loader>
        <p v-html="C_loadingMessage"></p>
      </div>
      <div v-else class="p2s2m2_main_container">
        <div class="p2s2m2_buttons_area">
          <div class="p2s2m2_search_area">
            <i class="p2s2m2_search_icon fa fa-search"></i>
            <input ref="search" class="p2s2m2_search_input" required @input="updateSearchQuery" placeholder="Search for Organization or Group" type="text">
            <button class="p2s2m2_clear_search_icon p2s2m2_clear_btn" @click="clearSearch" value="X"></button>
          </div>
          <div>
            <button class="p2s1_button p2s1_button1" @click.stop="expandAll"></button>
            <button class="p2s1_button p2s1_button2" @click.stop="collapseAll"></button>
          </div>
        </div>

        <c3-grouped-orgs-tree
          v-if="DV_locationPreset != null && DV_locationPreset != {} && DV_activePreset != null && DV_activePreset in DV_locationPreset"
          :location="DV_locationPreset[DV_activePreset]"
          :depth="0"
          :active-org="DV_activeOrg"
          :search-query="DV_searchQuery"
          :presetName="DV_activePreset"
          :expandCollapseCommand="DV_expandCollapseAllCommand"
          :searchQueryRequestTimestamp="DV_searchQueryRequestTimestamp"
          class="p2s2m2_root_tree_component"
          @pass-select-org="setActiveOrg"
          @pass-event-show-group-detail="eventShowGroupDetail"
          @pass-event-create-new-group="createNewGroup"
          @pass-event-unselect-selected-item="eventUnSelectItem"
        ></c3-grouped-orgs-tree>
      </div>
    </div>

    <c3m1-notification-group-details 
      v-if="activeModal=='c3m1'"
      :isModal="true"
      :subItemIndex="subItemIndex + 1"
      :subItemsList="subItemsList"
      :parentParams="params"
      :parentTitle="modalTitle"
      :active-group="DV_activeGroup"
      :active-org="DV_activeOrg"
      @event-close-modal="eventCloseModal"
      @event-sub-items-change="eventSubItemsChange"
      @event-parameter-change="eventParamsChange"
      @event-sub-items-loaded="eventSubItemsLoaded"
    ></c3m1-notification-group-details>

    <c3m2-create-new-group 
      v-if="activeModal === 'c3m2' && DV_activeOrg !== ''"
      :orgUid="DV_activeOrg"
      :isModal="true"
      :subItemIndex="subItemIndex + 1"
      :subItemsList="subItemsList"
      :parentParams="params"
      :parentTitle="modalTitle"
      @event-close-modal="eventCloseModal"
      @event-sub-items-change="eventSubItemsChange"
      @event-parameter-change="eventParamsChange"
      @event-sub-items-loaded="eventSubItemsLoaded"
    ></c3m2-create-new-group>
  </div>
</template>

<script>
/* eslint-disable */
import ModalHeader from "../p2ModalHeader";
import { bi10ModalTemplate } from "../../../watchdog_includes/base_i10_UI_mixins";
import c3GroupedOrgsTree from "./p2s2m2/c3GroupedOrgsTree";
import c3m1NotificationGroupDetails from "./p2s2m2/c3m1NotificationGroupDetails";
import c3m2CreateNewGroup from "./p2s2m2/c3m2CreateNewGroup";
import _ from 'lodash';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue'

export default {
  name: "p2s2m2NotificationGroups",
  mixins: [bi10ModalTemplate],
  components: {
    ModalHeader,
    c3GroupedOrgsTree,
    c3m2CreateNewGroup,
    c3m1NotificationGroupDetails,
    BeatLoader
  },
  data: function() {
    return {
      modalTitle: 'Manage Notification Groups',
      defaultModal: 'default',
      DV_locationPreset: {},
      DV_activePreset: null,
      DV_searchQuery: '',
      DV_searchQueryRequestTimestamp: null,
      DV_activeOrg: '',
      DV_activeGroup: null,
      DV_orgCountAndLoading: {},
      DV_loadedOrgsCount: 0,
      DV_timeElapsed: 0,
      DV_expandCollapseAllCommand: null
    };
  },
  computed: {
    C_loadingTime() {
      // approximate time to load 1 organization is 0.28 seconds.
      return Math.ceil(0.028 * this.DV_loadedOrgsCount);
    },
    C_loadingMessage() {
      return `Please wait while we load organization's data completely. Loading <b>${this.DV_loadedOrgsCount}</b> organizations. This should take around <b>${this.C_loadingTime}</b> seconds. Time Elapsed: <b>${this.DV_timeElapsed}</b> seconds.`
    },
    C_isLoadingOrgs() {
      return this.DV_orgCountAndLoading['is_loading'] === true;
    },
    C_loaderColor() {
      return window.G_brand_color;
    },
  },
  methods: {
    waitWatchdogReadyCallback() {
      this.DV_locationPreset = window.G_watchdog_data.IV_presets;
      this.DV_activePreset = "all_preset";
      this.DV_orgCountAndLoading = window.vue_instance.$data.watchdog.orgCountAndLoading;
      window.G_watchdog_data.bi7InitNGPUserGlobalJoins();
      var parse_props =  [
        { prop_name: "orgUid", functions: [this.setActiveOrg] },
        { prop_name: "ngpUid", functions: [this.eventShowGroupDetail] },
      ];
      this.parseRouteParams(parse_props)
    },
    updateSearchQuery: _.debounce(
      function(input) {        
        if (this.$refs.search.value === "") {
          this.DV_searchQuery = '';
        } else {
          this.DV_searchQuery = this.$refs.search.value;
          this.DV_searchQueryRequestTimestamp = new Date().getTime();
        } 
      },
      200
    ),
    clearSearch() {
      this.DV_searchQuery = '';
      this.$refs.search.value = '';
      this.eventUnSelectItem();
      this.DV_searchQueryRequestTimestamp = null;
    },
    setActiveOrg(org_uid) {
      this.params['0-org'] = org_uid;
      this.updateParams();
      this.DV_activeOrg = org_uid;
    },
    eventUnSelectItem() {
      this.params['0-org'] = null;
      this.params['1-ngp'] = null;
      this.updateParams();
      this.DV_activeOrg = '';
      this.DV_activeGroup = null;
    },
    eventShowGroupDetail(group_id) {
      this.params['0-org'] = this.DV_activeOrg;
      this.params['1-ngp'] = group_id;
      this.DV_activeGroup = group_id;
      this.updateParams();
      this.showModal("c3m1");
    },
    createNewGroup() {
      this.params['1-ngp'] = null;
      this.updateParams();
      this.showModal("c3m2");
    },
    startCounter() {
      if (this.C_isLoadingOrgs == false) {
        return;
      } else {
        this.DV_timeElapsed += 1;
        setTimeout(this.startCounter, 1000);
      }
    },
    expandAll() {
      this.resetActiveOrgAndGroup();
      this.DV_expandCollapseAllCommand = "E" + new Date().getTime().toString();
    },
    collapseAll() {
      this.resetActiveOrgAndGroup();
      this.DV_expandCollapseAllCommand = "C" + new Date().getTime().toString();
    },
    resetActiveOrgAndGroup() {
      this.params['0-org'] = null;
      this.params['1-ngp'] = null;
      this.DV_activeGroup = null;
      this.DV_activeOrg = '';
      this.updateParams();
    }
  },
  watch: {
    DV_orgCountAndLoading: {
      handler: function(val) {
        if (this.DV_orgCountAndLoading['org_count'] !== undefined && this.DV_orgCountAndLoading['org_count'] !== null) {
          this.DV_loadedOrgsCount = this.DV_orgCountAndLoading['org_count'];
          this.startCounter();
        }
      },
      deep: true
    }
  },
  beforeDestroy() {
  	window.G_watchdog_data.removeNGPUserGlobalJoinsListener()
  }
};
</script>



// WEBPACK FOOTER //
// src/components/p2Dashboard/p2s2notifications/p2s2m2NotificationGroups.vue